"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdResponsive = _interopRequireDefault(require("cccisd-responsive"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _checkmarkCircle = _interopRequireDefault(require("cccisd-icons/svg/checkmark-circle"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _helpers = require("./helpers.js");
var _style = _interopRequireDefault(require("./style.css"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DefaultTemplate = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(DefaultTemplate, _React$Component);
  function DefaultTemplate() {
    var _this;
    _classCallCheck(this, DefaultTemplate);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DefaultTemplate, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_goToComponent", function (id) {
      _this.props.goToComponent(id);
    });
    return _this;
  }
  _createClass(DefaultTemplate, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        settings = _this$props.settings,
        question = _this$props.question,
        elementStyle = _this$props.elementStyle;
      var children = this.props.children.map(function (child) {
        var hasImage = child.settings.content.content && child.settings.content.content.includes('<img');
        return _objectSpread(_objectSpread({}, child), {}, {
          hasImage: hasImage,
          content: hasImage ? _objectSpread(_objectSpread({}, child.settings.content), {}, {
            content: child.settings.content.content.replace(/[\s\S]*(<img[^>]+>)[\s\S]*/, '$1')
          }) : child.settings.content
        });
      });
      var totalChildren = children.length;
      return /*#__PURE__*/_react["default"].createElement(_cccisdResponsive["default"], {
        stylesheet: _style["default"],
        widthBreakpoints: {
          xsmall: 500,
          small: 640,
          medium: 860
        }
      }, question && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_common["default"].lastRow, _common["default"].elementWrapper, _common["default"][elementStyle]),
        style: {
          marginBottom: '1em'
        }
      }, question), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrapper + ' ' + _style["default"][settings.layoutType]
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].content + ' ' + _style["default"]["number".concat(totalChildren)]
      }, children.map(function (child) {
        var isImage = settings.showItemAs === 'image';
        var content = typeof child.settings.content === 'string' ? child.settings.content : child.settings.content.content;
        var label = (0, _cccisdSurveyCommon.stripTags)(content, {
          keepImageAltText: false,
          keepTextStyle: true
        }).trim();
        var imageUrl = (0, _helpers.getFirstImageSrc)(content);
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: child.id
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].itemWrapper + ' ' + _style["default"]["shape-".concat(settings.shape)],
          onClick: _this2._goToComponent.bind(_this2, child.id)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].item,
          style: _objectSpread({}, isImage && {
            backgroundImage: "url(".concat(imageUrl, ")")
          })
        }, child.progressState === 'finished' && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].checkmark
        }, "Complete", /*#__PURE__*/_react["default"].createElement(_checkmarkCircle["default"], null)), !isImage && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: child.settings.content
        })), isImage && label && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].label
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: label
        }))), ['circle', 'square'].includes(settings.shape) && /*#__PURE__*/_react["default"].createElement("p", {
          className: _style["default"]["break"]
        }));
      }))));
    }
  }]);
  return DefaultTemplate;
}(_react["default"].Component);
_defineProperty(DefaultTemplate, "propTypes", {
  // Children of the menu
  children: _propTypes["default"].array,
  // Callback to redirect player to different component
  goToComponent: _propTypes["default"].func,
  question: _propTypes["default"].node,
  // ===========================================================================
  // Advanced props (use them if you know what you are doing)
  // ===========================================================================
  // Object with all html settings
  settings: _propTypes["default"].object,
  elementStyle: _propTypes["default"].string
});